class LoginForm {
  constructor() {
    this.loginFormInit();
    this.rememberMeCheckbox();
  }

  loginFormInit = () => {
    const labels = document.querySelectorAll(".js-login-label");
    labels.forEach((label) => {
      let input = label.querySelector("input");
      if (input.value != "") {
        label.classList.add("input");
      }
      input.addEventListener("animationstart", (e) => {
        if (e.animationName == "onAutoFillStart") {
          label.classList.add("active");
        }
      });
      input.addEventListener("focus", () => {
        labels.forEach((l) => {
          if (l != label) {
            l.classList.remove("active");
          }
        });
        label.classList.add("active");
      });
      input.addEventListener("input", (e) => {
        if (e.target.value != "") {
          label.classList.add("input");
        } else {
          label.classList.remove("input");
        }
      });
    });
  };

  rememberMeCheckbox = () => {
    const customCheckbox = document.querySelector(".js-custom-checkbox");
    const input = document.querySelector(".js-input-checkbox");
    input.addEventListener("change", () => {
      input.checked == true
        ? customCheckbox.classList.add("active")
        : customCheckbox.classList.remove("active");
    });
  };
}

new LoginForm();
